import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { MenuItem, ModifierOption, ModifierGroups, EditModifierOptions, ModifierGroup, Modifier, OrdersWithPayment } from '../../models/order';
import { OrderService } from 'src/app/order.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from 'src/app/models/store';
import { StoreService } from 'src/app/_services/store.service';
import { QuantityChange } from '../quantity-control/quantity-control.component';
import { AnalyticsService } from 'src/app/_services/analytics.service';

@Component({
  selector: 'app-menu-item-master',
  templateUrl: './menu-item-master.component.html',
  styleUrls: ['./menu-item-master.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuItemMasterComponent implements OnInit {

  title: string;
  description: string;
  selectedMenuItem: MenuItem;
  menuGroupItems: MenuItem[];
  storeId: string;
  menuItemGroupId: string;
  menuItemId: string;
  parsedMenuItemId: string;
  modifierGroups: ModifierGroup[];
  quantity: number;
  specialRequest: string;
  orderId: string;
  selectedModifiers: Modifier[];
  // isPizza:Boolean;
  isLoading = true;
  selectedItemTotal: number = 0
  selectedModifiersTotal: number = 0
  modCounter: Map<number, number>;
  isValid: boolean = false;
  store: Store;
  menuItemGroup;
  uiSetting: any;
  availableQty: number;
  currentIndex = 0;
  isCatering = false;

  constructor(
    private route: ActivatedRoute,
    private orderService: OrderService,
    private router: Router,
    private storeService: StoreService,
    private cdr: ChangeDetectorRef,
    private analyticsService: AnalyticsService
  ) { }

  ngOnInit() {
    this.orderId = this.route.snapshot.paramMap.get('orderId');
    this.storeId = this.route.snapshot.paramMap.get('storeId');
    this.menuItemGroupId = this.route.snapshot.paramMap.get('menuItemGroupId');

    this.menuItemId = this.route.snapshot.paramMap.get('menuItemId');
    this.parsedMenuItemId = this.route.snapshot.paramMap.get('parsedMenuItem');
    this.quantity = 1
    this.orderService.getOrder(this.orderId, "0").subscribe(data => {
      let orderWithPayment = Object.assign(new OrdersWithPayment(), data);
      if (orderWithPayment.bot_order.is_submitted) {
        this.router.navigate(['order', this.orderId, 'status', 'success']);
      }
      this.cdr.markForCheck();
    })

    this.orderService.getStoreInfo(this.storeId).subscribe(store => {
      this.store = Object.assign(new Store(), store);
      this.storeService.changeStore(this.store);
      this.uiSetting = this.store.ui_settings;
      this.cdr.markForCheck();
      this.orderService.getMenuGroup(this.storeId, +this.menuItemGroupId).subscribe(data => {
        this.menuItemGroup = data;
        // Group-level description (what the menu card shows) when the portion has none of its own.
        if (!this.description) this.description = this.groupDescription();
        // this.isPizza = data.menu_group.name.toLowerCase().includes("pizza")
        this.cdr.markForCheck();
      })

      this.isCatering = this.route.snapshot.queryParamMap.get('catering') === 'true';
      const isCatering = this.isCatering;
      this.orderService.getMenuItemGroupOptionsForStore(this.storeId, this.menuItemGroupId, isCatering)
        .subscribe(data => {
          this.menuGroupItems = data.filter(m => !m.is_pos_only);

          if (isCatering) {
            this.menuGroupItems = this.menuGroupItems.filter(item => item.show_on_catering_menu !== false);
          }

          if (this.menuGroupItems.length === 0) {
            this.goBack();
            return;
          }

          if (this.menuItemId) {
            this.selectedMenuItem = this.menuGroupItems.find(p => p.id === +this.menuItemId);
          } else {
            this.selectedMenuItem = this.menuGroupItems.filter(m => m.is_available)[0];
          }

          if (this.selectedMenuItem) {
            this.availableQty = this.selectedMenuItem.available_qty;

            this.orderService.getModifiersForMenuItem(this.storeId, this.selectedMenuItem.id.toString()).subscribe(data => {
              this.title = data.menu_item.display_name;
              this.description = data.menu_item.description || this.groupDescription();
              this.modifierGroups = data.modifier_groups
                .sort((x, y) => Number(y.is_required) - Number(x.is_required))
                .map(p => Object.assign(new ModifierGroup(), p));

              this.selectedItemTotal = this.selectedMenuItem.base_price;
              this.analyticsService.trackEvent('view_item', {
                item_id: this.selectedMenuItem.id,
                item_name: this.title,
                price: this.selectedMenuItem.base_price,
                store_id: this.storeId
              });

              // ✅ If editing an existing item
              if (this.parsedMenuItemId) {
                this.orderService.getModifiers(this.orderId, this.parsedMenuItemId).subscribe(data => {
                  this.specialRequest = data.parsed_menu_item.special_request;
                  this.quantity = data.parsed_menu_item.quantity;

                  let modifierOptions = Object.assign(new EditModifierOptions(), data);
                  let existing_modifiers = modifierOptions.parsed_menu_item.modifiers.filter(m => m.modifier != null);

                  this.selectedModifiers = existing_modifiers.map(m => Object.assign(new ModifierOption(), m));
                  this.selectedModifiersTotal = +this.selectedModifiers.reduce((sum, mod) => sum + +mod.getUpcharge(), 0);
                  this.isLoading = false;

                  if (this.modifierGroups) {
                    this.selectedModifiers.forEach(selectedMod => {
                      const modifierGroupId = selectedMod.modifier.modifier_group;
                      const modifierId = selectedMod.modifier.id;
                      const modifierGroup = this.modifierGroups.find(group => group.id === modifierGroupId);

                      if (modifierGroup) {
                        modifierGroup.options.forEach(option => {
                          if (option.id === modifierId) {
                            option.mod_type = selectedMod.mod_type;
                          }
                        });
                      }
                    });
                  }

                  // Rebuild nested sub-modifier state so the inline picker
                  // shows the saved picks and validity passes on reopen.
                  this.rehydrateNestedSelections();
                  this.cdr.markForCheck();
                });
              } else {
                const isPreselectEnabled = this.store['feature_flag']?.['preselected_default_pos_mod'];

                if (isPreselectEnabled) {
                  // ✅ Feature flag is enabled → apply preselected modifiers
                  const preselectedMods: Modifier[] = [];

                  this.modifierGroups.forEach(group => {
                    group.options.forEach(option => {
                      if (option['preselect_default']) {
                        const alreadyExists = preselectedMods.find(m => m.modifier.id === option.id);
                        if (!alreadyExists) {
                          const mod = new Modifier();
                          mod.modifier = option;
                          mod.quantity = option['preselect_quantity'];
                          mod.mod_type = 'ADD';
                          preselectedMods.push(mod);
                        }
                      }
                    });
                  });

                  this.selectedModifiers = preselectedMods;

                  // ✅ Recalculate price
                  this.selectedModifiersTotal = +this.selectedModifiers.reduce((sum, mod) => {
                    return sum + +mod.getUpcharge();
                  }, 0);
                } else {
                  // ❌ Feature flag is off → preserve original behavior (no preselects)
                  this.selectedModifiers = [];
                  this.selectedModifiersTotal = 0;
                }
              }
              this.cdr.markForCheck();
            });
          }

          this.isLoading = false;
          this.cdr.markForCheck();
        });

    })
  }

  /** Menu-group description, or '' (the API sends 0 for none). */
  private groupDescription(): string {
    const d = (this.menuItemGroup as any)?.description;
    return d && d != 0 ? String(d) : '';
  }

  goBack() {
    window.history.back()
  }

  /**
   * Edit mode: the saved order payload doesn't carry nested linkage, so we
   * rebuild it from the menu tree (which has `sub_modifier_groups` attached
   * when the flag is on). For each selected option we attach its sub-groups
   * (needed for the picker + validity) and infer `parentModifierId` from the
   * catalog structure when its parent is also selected. No-op when the flag
   * is off, so legacy behaviour is unchanged.
   */
  private rehydrateNestedSelections(): void {
    if (!this.store?.isEnabled('sub_modifiers_enabled') || !this.modifierGroups || !this.selectedModifiers) {
      return;
    }
    const subGroupsByOption = new Map<number, ModifierGroup[]>();
    const parentByChildOption = new Map<number, number>();
    const walk = (groups: ModifierGroup[], parentOptionId?: number) => {
      for (const g of groups || []) {
        for (const o of g.options || []) {
          if (parentOptionId != null) {
            parentByChildOption.set(o.id, parentOptionId);
          }
          const subs = o.sub_modifier_groups;
          if (Array.isArray(subs) && subs.length) {
            subGroupsByOption.set(o.id, subs);
            walk(subs, o.id);
          }
        }
      }
    };
    walk(this.modifierGroups);

    const selectedIds = new Set(this.selectedModifiers.map(m => m.modifier?.id));
    this.selectedModifiers.forEach(m => {
      const optId = m.modifier?.id;
      if (optId == null) {
        return;
      }
      const subs = subGroupsByOption.get(optId);
      if (subs) {
        (m.modifier as ModifierOption).sub_modifier_groups = subs;
      }
      const parentId = parentByChildOption.get(optId);
      if (parentId != null && selectedIds.has(parentId)) {
        m.parentModifierId = parentId;
      }
    });
  }

  getQuantity(value: QuantityChange) {
    this.quantity = value.quantity;
  }

  getSpecialRequest(value: string) {
    this.specialRequest = value;
  }

  checkModifierConstrains(value) {
    this.isValid = value
  }

  getSelectedModifiers(values: Modifier[]) {
    this.selectedModifiersTotal = 0
    this.selectedModifiers = values;
    this.selectedModifiers.forEach(m => {
      if (m.mod_tag === 'No') {
        return; // skip adding any charges for this modifier
      }
      if (m.modifier.half_mod_upcharge == null) {
        let upcharge = m.mod_type === "H1" || m.mod_type === "H2" ? +m.getUpcharge() / 2.0 : +m.getUpcharge();
        this.selectedModifiersTotal = +this.selectedModifiersTotal + upcharge

      } else {
        if (m.mod_type === "H1" || m.mod_type === "H2") {
          if (m.modifier.half_mod_upcharge == null) {
            let upcharge = m.mod_type === "H1" || m.mod_type === "H2" ? +m.getUpcharge() / 2.0 : +m.getUpcharge();
            this.selectedModifiersTotal = +this.selectedModifiersTotal + upcharge
          } else {
            let upcharge = m.getUpcharge();
            this.selectedModifiersTotal = +this.selectedModifiersTotal + upcharge

          }
        } else {
          let upcharge = +m.getUpcharge();
          this.selectedModifiersTotal = +this.selectedModifiersTotal + upcharge
        }
      }

      if (m.modifier.mod_tag === 'No' && m.modifier.no_tag_upcharge) {
        this.selectedModifiersTotal = +this.selectedModifiersTotal + m.modifier.no_tag_upcharge
      } else if (m.modifier.mod_tag === 'Lite' && m.modifier.lite_tag_upcharge) {
        this.selectedModifiersTotal = +this.selectedModifiersTotal + m.modifier.lite_tag_upcharge
      } else if (m.modifier.mod_tag === 'Extra' && m.modifier.extra_tag_upcharge) {
        this.selectedModifiersTotal = +this.selectedModifiersTotal + m.modifier.extra_tag_upcharge
      } else if (m.modifier.mod_tag === 'On Side' && m.modifier.onside_tag_upcharge) {
        this.selectedModifiersTotal = +this.selectedModifiersTotal + m.modifier.onside_tag_upcharge
      } else if (m.modifier.mod_tag === 'Sub' && m.modifier.sub_tag_upcharge) {
        this.selectedModifiersTotal = +this.selectedModifiersTotal + m.modifier.sub_tag_upcharge
      }
    })
  }

  getPortionChange(value: MenuItem) {
    this.isLoading = true
    this.selectedMenuItem = value;
    this.selectedModifiers = [];
    this.selectedModifiersTotal = 0
    this.orderService.getModifiersForMenuItem(this.storeId, this.selectedMenuItem.id.toString()).subscribe(data => {
      this.title = data.menu_item.display_name
      this.modifierGroups = data.modifier_groups.sort((x, y) => Number(y.is_required) - Number(x.is_required)).map(p => Object.assign(new ModifierGroups(), p));
      this.isLoading = false
      const isPreselectEnabled = this.store['feature_flag']?.['preselected_default_pos_mod'];
      if (isPreselectEnabled) {
        const preselectedMods: Modifier[] = [];

        this.modifierGroups.forEach(group => {
          group.options.forEach(option => {
            if (option['preselect_default']) {
              const exists = preselectedMods.find(m => m.modifier.id === option.id);
              if (!exists) {
                const mod = new Modifier();
                mod.modifier = option;
                mod.quantity = option['preselect_quantity'];
                mod.mod_type = 'ADD';
                preselectedMods.push(mod);
              }
            }
          });
        });

        this.selectedModifiers = preselectedMods;
        this.getSelectedModifiers(this.selectedModifiers);
      }

      this.selectedItemTotal = this.selectedMenuItem.base_price
      this.cdr.markForCheck();
    })
  }

  updateItem() {
    if (!this.selectedMenuItem) {
      return;
    }
    if (this.parsedMenuItemId) {
      this.selectedModifiers.forEach(mod => {
        if (mod.mod_tag && mod.modifier) {
          mod.modifier.mod_tag = mod.mod_tag;
        }
      });
      this.orderService.updateItem(this.orderId, this.parsedMenuItemId, this.selectedMenuItem.id.toString(),
        this.selectedModifiers, this.quantity, this.specialRequest).subscribe(() => {
          this.router.navigate(['order', this.orderId]);
        });
    } else {
      this.analyticsService.trackEvent('add_to_cart', {
        item_id: this.selectedMenuItem.id,
        item_name: this.title,
        price: this.selectedMenuItem.base_price,
        quantity: this.quantity,
        store_id: this.storeId
      });
      this.orderService.addnewItem(this.orderId, this.selectedMenuItem.id.toString(), this.selectedModifiers,
        this.quantity, this.specialRequest).subscribe(() => {
          this.router.navigate(['order', this.orderId]);
        });
    }
  }
  prev() {
    this.currentIndex = (this.currentIndex > 0) ? this.currentIndex - 1 : this.menuItemGroup.latest_image.length - 1;
  }

  next() {
    this.currentIndex = (this.currentIndex < this.menuItemGroup.latest_image.length - 1) ? this.currentIndex + 1 : 0;
  }
}
